
let isLoading = false;
const loadItems = (button) => {
	if (isLoading) return;
	isLoading = true
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
	const rawValue = document.querySelector('[data-next-url]').value

	const getUrlWithoutPhcursor = (value, pageValue) => {
		const url = new URL(value, window.location.origin)
		url.searchParams.set('page', pageValue)
		url.searchParams.delete('phcursor')
		return url.pathname + '?' + url.searchParams.toString()
	}

	const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage)
	const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll)
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      // Запоминаем текущую позицию прокрутки
      const currentScrollTop = $(window).scrollTop();

      // Добавляем новые элементы
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();

      if (typeof window.monochromeInitProductCardSwipers === "function") {
        var gridRoot = document.querySelector(".load-more-grid");
        window.monochromeInitProductCardSwipers(gridRoot || document);
      }

      // Восстанавливаем предыдущую позицию прокрутки
      $(window).scrollTop(currentScrollTop);
    },
    complete: function () {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }

				setTimeout(() => {
					isLoading = false
				}, 200)
      }
    }
  });
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  });
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
